var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnWarning = function SvgIcnWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.171 15.398-5.912-9.854C14.483 4.251 13.296 3.511 12 3.511c-1.296 0-2.483.74-3.259 2.031l-5.912 9.856c-.786 1.31-.872 2.705-.235 3.83C3.23 20.354 4.472 21 6 21h12c1.528 0 2.77-.646 3.406-1.77.637-1.126.551-2.522-.235-3.832ZM12 17.55c-.854 0-1.55-.695-1.55-1.549 0-.855.695-1.55 1.55-1.55.855 0 1.55.695 1.55 1.55 0 .854-.696 1.55-1.55 1.55Zm1.633-7.424c-.011.031-1.401 3.468-1.401 3.468a.25.25 0 0 1-.231.156.25.25 0 0 1-.231-.156l-1.391-3.438a1.776 1.776 0 0 1-.129-.655c0-.965.785-1.75 1.75-1.75a1.752 1.752 0 0 1 1.633 2.375Z",
    fill: "#FF2D46"
  })));
};
export default SvgIcnWarning;